import { FC, useEffect, useState } from "react";

import { Checkbox, FormControlLabel, Stack } from "@mui/material";

import { CommissionPayRollModel } from "../CommissionPayRoll/CommissionPayRoll";

interface CommissionPayRollItemProps {
    payRoll: CommissionPayRollModel;
}

const CommissionPayRollItem: FC<CommissionPayRollItemProps> = ({ payRoll }) => {

    const [paid, setPaid] = useState<boolean>(false);
    useEffect(() => {
        setPaid(payRoll.isPaid === 1);
    }, [payRoll])

    function IsPaidChanged(event: any) {
        var value: boolean = event.target.checked;
        setPaid(value);
        payRoll.isPaid = value ? 1 : 0;
    }

    return (

        <Stack
            direction={"column"}
            spacing={1}
            sx={{ border: '1px solid black', padding: '10px', margin: '10px' }}
        >
            <Stack
                direction={"row"}
                spacing={2}
                alignContent={"center"}>

                <span style={{ width: "130px" }}>{payRoll.salesman}</span>
                <span style={{ width: "130px" }}>{payRoll.company}</span>
                <span style={{ width: "70px" }}>{payRoll.reportDate}</span>
                <span style={{ width: "100px" }}>£{payRoll.amount.toFixed(2)}</span>

                {payRoll.paymentDateStr !== null ?
                    <span>paid date: {payRoll.paymentDateStr}</span>
                    : <FormControlLabel
                        label="Is paid"
                        control={
                            <Checkbox
                                sx={{ marginLeft: '-13px', height: '20px' }}
                                checked={paid}
                                onChange={IsPaidChanged}
                            />
                        } />
                }
            </Stack>
            {payRoll.xeroInvoiceStatuses.map((item) => (
                <Stack
                    key={item.id}
                    direction={"row"}
                    spacing={2}
                    alignItems={"center"}
                    sx={{ margin: '0px' }}>
                    <p style={{ margin: '0px', width: "145px" }}>{item.number}</p>
                    <p style={{ margin: '0px', width: "145px" }}>{item.status}</p>
                    <p style={{ margin: '0px' }}>{item.invoicePayDate}</p>
                </Stack>
            ))}
        </Stack>


    )
}

export default CommissionPayRollItem;